import DeployAction from './DeployAction';
import ScenarioAction from './ScenarioAction';

export default [ScenarioAction, DeployAction];
